var widget_default = {
  "card": "Cps3w",
  "link": "X3plR",
  "container": "Rnzib",
  "image": "BijRS",
  "right": "vtufg",
  "cardLayout": "FTCGu",
  "content": "on2uj",
  "title": "ivYI-",
  "subtitle": "sF0eE",
  "button": "qeJNx",
  "button_disabled": "kCYep",
  "buttonText": "_5jx7y",
  "slimLayout": "hKinp",
  "contentText": "cwRNP"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
